import React, { useContext, useEffect, useState } from "react";
import style from "./index.module.scss";
import { Radio } from "antd";
import {
    findOneValue,
    OptionItem,
    TopicsItem
} from "../../../../../../../API/exercise";
import { RadioChangeEvent } from "antd/lib/radio";
import { ExerciseContext } from "../../../../../Store";

interface PageJudgeProps {
    index?: number;
    data: TopicsItem;
    oneSave: (questionId: string, value: string) => void;
}

export default function PageJudge({ data, oneSave, index }: PageJudgeProps) {
    const [value, setValue] = useState("");
    const { exercise } = useContext(ExerciseContext);

    useEffect(() => {
        if (data.id && exercise.length > 0) {
            let val = findOneValue(data.id, exercise);
            setValue(val);
        }
    }, [data, exercise]);

    function radioChange(event: RadioChangeEvent) {
        setValue(event.target.value);
        oneSave(data.id, event.target.value);
    }

    return (
        <div className={style.root}>
            <div>
                {data.index && (
                    <span className={style.index}>{data.index}. </span>
                )}

                {index && <span className={style.index}>({index}). </span>}
                <span className={style.score}>（判断题，{data.score}分）</span>
            </div>
            <div className={style.title}>
                <span
                    dangerouslySetInnerHTML={{
                        __html: data.contentText
                    }}
                />
            </div>

            <div className={style.options}>
                <Radio.Group onChange={radioChange} value={parseInt(value)}>
                    {data.options &&
                        data.options.map((item: OptionItem, index: number) => (
                            <Radio
                                value={item.id}
                                className={style.radioStyle}
                                key={item.id}>
                                <span
                                    className={style.spanHtml}
                                    dangerouslySetInnerHTML={{
                                        __html: item.description
                                    }}
                                />
                            </Radio>
                        ))}
                </Radio.Group>
            </div>
        </div>
    );
}
